import React, { memo } from 'react';
import { Page } from '@bonanza-social/navigation';
import SmarticoPromo from '../../components/SmarticoPromo/SmarticoPromo';

type SmarticoPromoModalProps = {
  url: string;
};

function SmarticoPromoModal({ url }: SmarticoPromoModalProps) {
  if (!url) {
    return null;
  }

  return (
    <Page>
      <SmarticoPromo url={url} />
    </Page>
  );
}

export default memo(SmarticoPromoModal);
